export const environment = {
    production: true,
    enableLogs: true,
    enableKiosk: false,
    is_prod: false,
    api: 'https://dev.mysuncash.com/api/kiosk.php',
    signalRServicesConfig: {
        excludeSignalRServices: false,
        appManager: {
            url: "http://localhost:61770/",
            hubName: "LWAppManagerHub",
        },
    },
};
